/** Allocation Plan tab footer FAQs. Answers are HTML for FAQItem / RenderHTML. */

export const LUMPSUM_PLANS_FAQS = [
  {
    title: 'What is Allocation Plan?',
    description:
      'Your Allocation Plan shows the changes recommended to bring your portfolio closer to your personalised investment strategy. It tells you which funds to sell, which funds to buy and how much to move between them.'
  },
  {
    title: 'How is my Rebalancing Plan different from my Allocation Plan?',
    description: [
      'Your Rebalancing Plan identifies underperforming funds and recommends suitable replacements within the same category. It keeps your overall category allocation and investment strategy unchanged.',
      'Your Allocation Plan also considers how your portfolio should be distributed across categories, based on your risk profile and preferences. It recommends changes to your category allocation while also addressing underperforming funds.'
    ].join('<br/><br/>')
  },
  {
    title: 'Is my Allocation Strategy personalised to me?',
    description:
      'Yes. We assess your risk profile through a detailed questionnaire and consider your investment preferences, financial situation and existing portfolio. These inputs help determine your recommended allocation across categories. This strategy forms the foundation for your Allocation, SIP, lump sum and withdrawal plans.'
  },
  {
    title: 'Why might my plan recommend selling a fund that is performing well?',
    description:
      'A fund can be performing well while its category has more allocation than your strategy recommends. Selling part of that investment can help reduce the excess allocation and move money towards categories that need more investment.'
  },
  {
    title: 'Why is my ideal lump sum strategy different from my ideal SIP strategy?',
    description: [
      'Both follow the same underlying Allocation Strategy. Your SIP strategy gradually directs monthly investments towards your ideal allocation.',
      'Your lump sum strategy considers your current portfolio, the amount being invested, the allocation available within each category and your existing exposure to individual funds. These factors can result in a different category or fund split.'
    ].join('<br/><br/>')
  },
  {
    title: 'What is the difference between my Core, Satellite and Goal Portfolios?',
    description: [
      '<ul class="list-disc pl-5">',
      '<li><strong>Core Portfolio:</strong> The foundation of your long-term wealth creation. It typically holds most of your long-term investments and is diversified in line with your risk profile and Allocation Strategy.</li>',
      '<li><strong>Satellite Portfolio:</strong> A smaller allocation, typically around 20%, for themes or ideas you believe in, such as manufacturing, defence or AI. It complements your Core Portfolio.</li>',
      '<li><strong>Goal Portfolio:</strong> Investments set aside for a specific goal, such as retirement, buying a home or your child’s education. Its strategy depends on the amount required and when you need it.</li>',
      '</ul>'
    ].join('')
  },
  {
    title: 'Why are some funds marked ‘Sell later’ instead of being recommended for sell?',
    description:
      'We may be deferring a sale because it would attract short-term capital gains (STCG) tax, or because your ELSS investment is still locked in. We’ll reassess these funds in your next plan and provide an updated recommendation based on the constraints applicable then.'
  },
  {
    title: 'Will I have to pay tax while reallocating funds?',
    description: [
      'Selling or switching funds may result in capital gains tax, depending on your gains and the applicable tax rules.',
      'Your plan aims to reduce the tax impact by avoiding short-term capital gains where possible. If a sale involving STCG is recommended, the expected benefits are assessed against the tax cost.'
    ].join('<br/><br/>')
  },
  {
    title: 'Do I need to invest additional money to follow my Allocation Plan?',
    description:
      'The recommended buy amounts do not, by themselves, mean you need to add fresh money. They will be funded by the recommended sales from your existing holdings. Read the sell and buy recommendations together to understand how money should move within your portfolio.'
  }
]
